<template>
    <div
        :class="{'room-graph-table': true, 'room-label-column-expanded':roomLabelColumnExpanded, 'new-reservation-data':!!newReservationData}"
        ref="room-graph-table">
        <div class="header-row" v-if="data"> <!--sticky-->
            <div class="fill"
                 :style="{
                    width: `${roomLabelColumnExpanded ? EXPANDED_ROOM_LABEL_COLUMN_WIDTH : ROOM_LABEL_COLUMN_WIDTH}px`,
                    height: `${HEADER_COLUMN_HEIGHT}px`}"
                 v-on:click="!preventClick?toggleRoomLabelColumn():undefined">
                <div :class="`icon ${roomLabelColumnExpanded?'icon--chevron-left':'icon--chevron-right'}`"/>
            </div>
            <div v-for="date in data.dates"
                 :class="{
                    day: true,
                    sunday: isSunday(date.date),
                    today: isToday(date.date)}"
                 :style="{
                    width: `${GRAPH_COLUMN_WIDTH}px`,
                    height: `${HEADER_COLUMN_HEIGHT}px`,
                    paddingBottom: '14px',
                    transform:`translateX(${horizontalShift-GRAPH_COLUMN_WIDTH}px)`}">
                <div style="margin-bottom: 4px">
                    {{ date.occupancyPercent !== undefined ? (date.occupancyPercent * 100) + ' %' : '' }}
                </div>
                <div class="day-label">{{ date.date.format('dd') }}</div>
                <div class="day-label week-day-label">{{ date.date.format('D') }}</div>
            </div>
        </div>
        <div class="graph-body" v-if="data">
            <div class="room-number-column"
                 :style="{width: `${roomLabelColumnExpanded ? EXPANDED_ROOM_LABEL_COLUMN_WIDTH : ROOM_LABEL_COLUMN_WIDTH}px`}">
                <div v-for="floorEntry in Object.entries(data.floors)">
                    <div
                        class="floor-row floor-title"
                        :style="{height:`${FLOOR_HEADER_HEIGHT}px`}"
                        v-on:click="!preventClick?toggleFloor(floorEntry[0]):undefined">
                        {{ $t('floor') }} {{ floorEntry[0] }}
                    </div>

                    <div class="rooms" v-if="floorEntry[1].expanded">
                        <div v-for="room in floorEntry[1].rooms"
                             :class="`room-row state-${room.state}`"
                             :style="{
                                width: `${ROOM_LABEL_COLUMN_WIDTH}px`,
                                height: `${ROOM_ROW_HEIGHT}px`}">
                            <div class="label">{{ room.label }}</div>
                            <div class="type" v-if="roomLabelColumnExpanded">{{ room.typeLabel }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rooms-data">
                <div v-for="floorEntry in Object.entries(data.floors)">
                    <div
                        class="floor-row"
                        :style="{height:`${FLOOR_HEADER_HEIGHT}px`}"
                        v-on:click="!preventClick?toggleFloor(floorEntry[0]):undefined">
                        <div :class="`icon ${floorEntry[1].expanded?'icon--chevron-up':'icon--chevron-down'}`"/>
                    </div>

                    <div class="rooms" v-if="floorEntry[1].expanded"
                         :style="{transform:`translateX(${horizontalShift-GRAPH_COLUMN_WIDTH}px)`}">
                        <div v-for="room in floorEntry[1].rooms"
                             class="room-row">
                            <div v-for="date in data.dates"
                                 class="grid-cell"
                                 :style="{
                                width: `${GRAPH_COLUMN_WIDTH}px`,
                                height: `${ROOM_ROW_HEIGHT}px`}"
                                 v-on:click="!preventClick?onGridClick(room.typeId,room.id, date.date):undefined"></div>

                            <div v-for="item in room.items"
                                 :class="`grid-item ${isPast(item.to) ? 'past' :''} type-${item.type} ${item.isGroup?'group':''} ${item.onClick && !preventClick?'clickable':''}`"
                                 :style="{
                                width: `${dateToX(item.to) - dateToX(item.from)}px`,
                                height: `${ROOM_ROW_HEIGHT-1}px`,
                                left: `${dateToX(item.from)}px`,
                                borderColor: item.borderColorOverride}"
                                 v-on:click="item.onClick && !preventClick?item.onClick():undefined">
                                <div class="node-indicator" v-if="item.note"/>
                                {{ item.label }}
                            </div>

                            <div v-if="newReservationData && newReservationData.roomId === room.id"
                                 :class="`grid-item type-new ${daysBetween(newReservationData.from, newReservationData.to)<=1?'small':''}`"
                                 :style="{
                                width: `${dateToX(newReservationData.to) - dateToX(newReservationData.from)}px`,
                                height: `${ROOM_ROW_HEIGHT-1}px`,
                                left: `${dateToX(newReservationData.from)}px`}">
                                {{ daysBetween(newReservationData.from, newReservationData.to) }}x<span
                                class="icon--moon-fill"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'state-loading':true, 'visible':!data || loadingBodyData}"/>
    </div>
</template>

<script>

import moment from 'moment';
import axios from 'axios';

const HEADER_COLUMN_HEIGHT = 74; // Pozor, musí být včetně paddingu
const ROOM_LABEL_COLUMN_WIDTH = 50;
const EXPANDED_ROOM_LABEL_COLUMN_WIDTH = 100;
const ROOM_ROW_HEIGHT = 40;
const GRAPH_COLUMN_WIDTH = 40;
const FLOOR_HEADER_HEIGHT = 30;

export default {
    name: 'room-graph-table',
    props: ['referenceDate', 'horizontalShift', 'preventClick', 'onNewReservationDataChanged'],
    data: function () {
        return {
            from: undefined,
            to: undefined,
            data: undefined,
            loadingBodyData: false,
            resizeDebounceTimer: undefined,
            newReservationData: undefined,
            roomLabelColumnExpanded: false,
            ROOM_ROW_HEIGHT,
            GRAPH_COLUMN_WIDTH,
            FLOOR_HEADER_HEIGHT,
            HEADER_COLUMN_HEIGHT,
            ROOM_LABEL_COLUMN_WIDTH,
            EXPANDED_ROOM_LABEL_COLUMN_WIDTH
        }
    },
    watch: {
        referenceDate: function () {
            this.calculateColumnsDates()
            this.generateDates()
            this.armDebounceTimer();
        },
        newReservationData: function () {
            this.onNewReservationDataChanged(this.newReservationData)
        }
    },
    methods: {
        calculateColumnsDates: function () {
            if (this.referenceDate) {
                const el = this.$refs['room-graph-table']
                if (el) {
                    const graphWidth = el.scrollWidth - ROOM_LABEL_COLUMN_WIDTH

                    const dayCount = Math.floor(graphWidth / GRAPH_COLUMN_WIDTH)
                    const leftCount = Math.floor(dayCount / 2) + 1;
                    const rightCount = dayCount - leftCount + 2;

                    const referenceDate = moment(this.referenceDate).startOf('day')

                    this.from = moment(referenceDate).subtract(leftCount, 'day')
                    this.to = moment(referenceDate).add(rightCount, 'day')
                }
            }
        },
        generateDates(data = this.data) {
            let dates = [];
            for (let date = this.from; !date.isAfter(this.to); date = moment(date).add(1, 'day')) {
                dates.push({
                    date,
                    occupancyPercent: undefined
                })
            }

            data.dates = dates
        },
        clearData() {
            this.loadingBodyData = true;

            const formerData = this.data;
            if (formerData) {
                const newData = Object.assign({}, {
                    ...formerData,
                    dates: [],
                    floors: {}
                })

                this.generateDates(newData)

                for (let date = this.from; !date.isAfter(this.to); date = moment(date).add(1, 'day')) {
                    newData.dates.push({
                        date,
                        occupancyPercent: undefined
                    })
                }

                Object.entries(formerData.floors).forEach(e => {
                    newData.floors[e[0]] = {
                        ...e[1],
                        rooms: e[1].rooms.map(r => (Object.assign({}, {
                            ...r,
                            items: []
                        })))
                    }
                })

                this.data = newData;
            }
        },
        loadData: function () {
            //this.clearData();
            this.loadingBodyData = true;

            if (!this.from || !this.to) {
                return;
            }

            const fromString = moment(this.from).format('yyyy-MM-DD')
            const toString = moment(this.to).format('yyyy-MM-DD')

            let query = `{
                    listRooms {
                        id
                        code
                        clean
                        inspection
                        floor_code
                        room_type_id
                        room_type {
                            technical
                            code
                        }
                    }

                    listCurrentRooms(departured: null, check_in_date: ":${toString}", check_out_date: "${fromString}:") {
                        items {
                            id
                            room_id
                            checkin_date
                            checkout_date
                            departured
                            current_account {
                                accomodation_prepayed
                            }
                            master_guest {
                                profile {
                                    full_name
                                }
                                guest_group {
                                    is_group
                                }
                            }
                        }
                    }

                    listRoomBlocks(target_date: "${fromString}:${toString}") {
                        items {
                            id
                            room_id
                            from_date
                            to_date
                            title
                            out_of_order
                        }
                    }

                    listReservationRooms(check_in_date: ":${toString}", check_out_date: "${fromString}:", cancelled: false, valid: true, checked_in: false) {
                        checkin_date
                        checkout_date
                        room_id
                        is_group
                        name
                        technical
                        note
                        status
                        option_date
                        has_prepayment
                        color
                        reservation_row_id
                        reservation_group_id
                    }
                }`;

            axios({
                data: query
            }).then(response => {
                console.log(response)

                const {listCurrentRooms, listReservationRooms, listRoomBlocks, listRooms} = response.data.data

                const data = {
                    dates: [],
                    floors: {}, // Indexované podle floor_code
                }

                for (let date = this.from; !date.isAfter(this.to); date = moment(date).add(1, 'day')) {
                    data.dates.push({
                        date,
                        occupancyPercent: undefined
                    })
                }

                const roomsById = new Map()

                const formerData = this.data

                listRooms.forEach(({floor_code, code, id, clean, inspection, room_type_id, room_type}) => {
                    // Inicializace patra, pokud neexistuje
                    if (!data.floors[floor_code]) {
                        data.floors[floor_code] = {
                            expanded: formerData ? formerData.floors[floor_code].expanded : true,
                            rooms: []
                        }
                    }

                    const room = {
                        id: id,
                        typeId: room_type_id,
                        typeLabel: room_type.code,
                        label: code,
                        state: inspection ? 'inspected' : clean ? 'clean' : 'dirty',
                        items: []
                    }

                    // Přidání pokoje
                    data.floors[floor_code].rooms.push(room)

                    roomsById.set(id, room)
                });

                listCurrentRooms.items.forEach(i => {
                    const room = roomsById.get(i.room_id)

                    if (room) {
                        const item = {
                            from: moment(i.checkin_date),
                            to: moment(i.checkout_date),
                            type: i.departured ? 'departured' : 'currently-occupied',
                            label: i.master_guest.profile.full_name,
                            isGroup: i.master_guest.guest_group.is_group,
                            onClick: () => {
                                window.location = `/#/guests/edit/${i.id}`
                            }
                        }

                        room.items.push(item)
                    }
                })

                listRoomBlocks.items.forEach(i => {
                    const room = roomsById.get(i.room_id)

                    if (room) {
                        const item = {
                            from: moment(i.from_date),
                            // Pokud null, zobrazí se do posledního zobrazeného datumu + 2 dny, aby to šlo za okraj
                            to: i.to_date ? moment(i.to_date) : moment(this.to).add(2, 'day'),
                            type: i.out_of_order ? 'fault' : 'blocation',
                            label: i.title,
                            onClick: () => {
                                window.location = `/#/blocation/edit/${i.room_id}/${moment(i.from_date).format('YYYY-MM-DD')}`
                            }
                        }

                        // Pokud from === to je to závada, která se vyřešila dřív, než začla :)
                        if (item.to.isAfter(item.from)) {
                            room.items.push(item)
                        }
                    }
                })

                listReservationRooms.forEach(i => {
                    if (i.room_id != null) {
                        const room = roomsById.get(i.room_id)

                        if (room) {
                            const item = {
                                from: moment(i.checkin_date),
                                to: moment(i.checkout_date),
                                type: 'reservation',
                                label: i.name,
                                isGroup: i.is_group,
                                note: i.note,
                                borderColorOverride: i.color ? '#' + i.color : undefined,
                                onClick: () => {
                                    window.location = `/#/bookings/edit/${i.reservation_group_id}/${i.reservation_row_id}`
                                }
                            }

                            room.items.push(item)
                        } else {
                            console.error('Missing room with ID ' + i.room_id)
                        }
                    }
                })

                this.data = data
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.loadingBodyData = false;
            });
        },
        onResize: function () {
            this.clearData()
            this.calculateColumnsDates()
            this.armDebounceTimer();
        },
        armDebounceTimer: function () {
            this.clearResizeDebounceTimer();
            this.resizeDebounceTimer = setTimeout(() => this.loadData(), 500)
        },
        clearResizeDebounceTimer: function () {
            if (this.resizeDebounceTimer) {
                clearTimeout(this.resizeDebounceTimer)
            }
        },
        toggleFloor(floorCode) {
            const floor = this.data.floors[floorCode]
            floor.expanded = !floor.expanded
        },
        toggleRoomLabelColumn() {
            this.roomLabelColumnExpanded = !this.roomLabelColumnExpanded;
        },
        dateToX(date) {
            const daysFromFirstDate = moment(date).diff(this.from, 'day')
            return daysFromFirstDate * GRAPH_COLUMN_WIDTH + GRAPH_COLUMN_WIDTH / 2
        },
        isSunday: function (date) {
            return moment(date).day() === 0
        },
        isToday: function (date) {
            return moment(date).isSame(moment(), 'day')
        },
        isPast: function (date) {
            return moment(date).isBefore(moment(), 'day')
        },
        onGridClick(roomTypeId, roomId, date) {
            if (this.newReservationData) {
                if (this.newReservationData.roomId === roomId) {
                    const dayDiff = moment(date).diff(this.newReservationData.from, 'day')
                    if (dayDiff > 0) {
                        this.newReservationData.to = date
                        return;
                    } else if (dayDiff < 0) {
                        this.newReservationData.to = this.newReservationData.from
                        this.newReservationData.from = date
                        return;
                    } else {
                        this.cancelNewReservation()
                        return;
                    }
                }
            }

            this.newReservationData = {
                roomTypeId,
                roomId,
                from: date,
                to: moment(date).add(1, 'day')
            }
        },
        cancelNewReservation: function () {
            this.newReservationData = undefined
        },
        daysBetween(from, to) {
            return Math.abs(moment(from).diff(to, 'day'))
        }
    },
    mounted: function () {
        this.calculateColumnsDates()
        this.armDebounceTimer();
    },
    created() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
        this.clearResizeDebounceTimer();
    }
}
</script>

<style lang="less" scoped>
@import "../../../less/_core/global/font_sizes.less";

.room-graph-table {
    user-select: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;

    &.new-reservation-data {
        margin-bottom: @r80;
    }

    &.room-label-column-expanded {
        .header-row .day:nth-child(2) {
            margin-left: 100px;
        }

        .rooms-data {
            margin-left: 100px;
            width: calc(100% - 100px);
        }
    }
}

.room-number-column {
}

.rooms-data {
    flex: 1;
}

.graph-body {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    position: relative;
}

.header-row {
    white-space: nowrap;
    overflow: hidden;
    font-weight: 500;
    position: relative;

    div {
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        vertical-align: bottom;
    }

    .day {
        align-items: center;

        &:nth-child(2) {
            margin-left: 50px;
        }

        &.sunday .day-label {
            color: #FF0000
        }

        .day-label.week-day-label {
            width: 21px;
            height: 21px;
        }

        &.today .day-label.week-day-label {
            background: #FFD200;
            border-radius: 100px;
        }
    }

    .fill {
        position: absolute;
        cursor: pointer;
        background: #eaf0f2;
        z-index: 10;

        .icon {
            position: absolute;
            right: 10px;
            bottom: 10px;
            color: #0099FF;
            font-weight: 600;
            font-size: 18px;
        }
    }
}

.rooms {
    position: relative;
    // overflow: hidden;
}

.room-row {
    display: flex;
    align-items: center;
    position: relative;

    .label {
        padding-left: 8px;
        font-weight: 500;
    }

    &.state-dirty {
        .label {
            color: #ff0000
        }
    }

    &.state-inspected {
        .label {
            color: #2EB375
        }
    }
}

.grid-cell {
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    min-width: 40px;
    flex: 0;

    &:hover {
        background: rgba(0, 0, 0, 0.05);

        @media (hover: none) {
            background: none
        }
    }
}

.day {
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
}

.floor-row {
    background: #D7E2E6;
    color: #5E544A;
    text-transform: uppercase;
    letter-spacing: 0.44px;
    font-weight: 500;
    display: flex;
    align-items: center;
    cursor: pointer;

    &.floor-title {
        white-space: nowrap;
        padding-left: 8px;
    }

    &:not(.floor-title) {
        justify-content: right;
        padding-right: 10px;
    }

    .icon {
        color: #0099FF;
        font-weight: 600;
        font-size: 18px;
    }
}

.grid-item {
    border-radius: 1000px;
    position: absolute;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 10px;
    white-space: nowrap;
    overflow: hidden;
    color: #5E544A;

    &.type-currently-occupied {
        background: #FFD60080;
        border: 1px solid #7F735C;
    }

    &.type-new {
        background: #5e544a;
        border: 1px solid #5E544A;
        color: #ffd200;
        pointer-events: none;

        &.small {
            padding-left: 5px;
        }
    }

    &.type-departured, &.type-fault.past, &.type-blocation.past {
        background: #BCBCBC99;
        border: 1px solid #00000000;
    }

    &.type-fault.past, &.type-blocation.past {
        font-style: italic;
    }

    &.type-fault {
        background: #FF000012;
        border: 1px solid #FF0000;
    }

    &.type-blocation {
        background: #9F9F9F1C;
        border: 1px solid #9F9F9F;
    }

    &.type-reservation {
        background: #FFFFFF54;
        border: 1px solid #C5D5DA;
    }

    &.group {
        border-width: 2px;
        font-weight: 600;
    }

    &.clickable {
        cursor: pointer;
        transition: 0.3s background-color;

        &:hover {
            &.type-currently-occupied {
                background: #FFD600;
            }

            &.type-reservation {
                background: #FFFFFFFF;
            }
        }
    }

    .node-indicator {
        width: 6px;
        height: 6px;
        min-width: 6px;
        background: #007aff;
        border-radius: 100px;
    }
}

.room-number-column {
    position: absolute;
    background: #eaf0f2;
    z-index: 10;

    .rooms .room-row {
        display: flex;
        gap: 6px
    }
}

.rooms-data {
    margin-left: 50px;
}

.grid-cell, .room-number-column .rooms, .header-row .day, .header-row .fill {
    border-right: 1px solid #D7E2E6;
}

.state-loading {
    height: 100%;
    position: absolute;
    z-index: 10;
    width: 100%;
    pointer-events: all;
    visibility: hidden;
    opacity: 0;
    transition: 0.5s all;

    &.visible {
        visibility: visible;
        opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/templates/part/ui/room-graph-table.vue